import React from 'react';
import CustomLink from 'components/TableLink';

const InventoryItemId = (props) => {
  const { itemDetails: { active = false, stock = 0, objectId = '' } = {}} = props;

  const getWarningIcon = () => {
    if (!active && stock > 0) {
      return <i className={'fa fa-warning text-warning ml-2'} />;
    }
    return null;
  };
  return(
    <div>
      <CustomLink
        text={objectId}
        linkTo={`/inventory-items/${objectId}`}
      />
      {getWarningIcon()}
    </div>
  );
};

export default InventoryItemId;